/**
 * Copyright (c) 2017 CRF Box Oy. All Rights Reserved. Company Confidential.
 */

import { CHANGE_TAB } from '../actions/actionTypes';

const initialParticipantDetailsState = {
  tab: 1
};

const participantDetailsReducer = (state = initialParticipantDetailsState, action) => {
  switch (action.type) {
    case CHANGE_TAB:
      return Object.assign({}, state, { tab: action.payload });
    default:
      return state;
  }
};

export default participantDetailsReducer;
